import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TimeTrackerTableComponent } from './time-tracker-table.component';
import { MaterialModule } from '@app/material.module';
import { TimeTrackerEntryModule } from '../time-tracker-entry/time-tracker-entry.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CustomDirectivesModule } from '@app/_directives/custom-directives.module';
import { DateFnsModule } from 'ngx-date-fns';
import { TimeTrackerTableCardComponent } from './time-tracker-table-card/time-tracker-table-card.component';
import { TimeTrackerTableCardContentDirective } from './time-tracker-table-card-content.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';

@NgModule({
  declarations: [TimeTrackerTableComponent, TimeTrackerTableCardComponent, TimeTrackerTableCardContentDirective],
  imports: [
    CommonModule,
    MaterialModule,
    TimeTrackerEntryModule,
    TranslateModule,
    NgScrollbarModule,
    FlexLayoutModule,
    NgxSkeletonLoaderModule,
    CustomDirectivesModule,
    ScrollingModule,
    ExperimentalScrollingModule,
    DateFnsModule,
  ],
  exports: [TimeTrackerTableComponent],
})
export class TimeTrackerTableModule {}
